import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authStatus: false,
    selectedTracks: [],
    user: {},
    isAdmin: false
  },
  mutations: {
    setAuthStatus(state, n) {
      state.authStatus = n;
    },
    addToSelectedTracks(state, n){
      state.selectedTracks.push(n);
    },
    removeFromSelectedTracks(state, n){
      state.selectedTracks.splice(n, 1);
    },
    clearTracks(state) {
      state.selectedTracks = [];
    },
    setUser(state, n) {
      state.user = n;
    },
    setIsAdmin(state, n) {
      state.isAdmin = n;
    }
  },
  actions: {
    setAuthStatus({ commit }, status) {
      commit("setAuthStatus", status);
    },
    addToSelectedTracks({ commit }, status) {
      if (this.state.selectedTracks.length < 4 && this.state.selectedTracks.length !== 3) {
        if (this.state.selectedTracks.find(x => x._id === status._id)) {
          return Promise.reject('This track is already in your crate');
        } else {
          commit('addToSelectedTracks', status);
        }
      } else {
        return Promise.reject('Track limit reached');
      }
    },
    removeFromSelectedTracks({ commit }, status) {
      commit('removeFromSelectedTracks', status);
    },
    clearTracks({ commit }){
      commit('clearTracks');
    },
    setUser({commit}, user) {
      commit('setUser', user);
    },
    setIsAdmin({commit}, isAdmin) {
      commit('setIsAdmin', isAdmin);
    }
  },
  getters: {
    getSelectedTracks: state => state.selectedTracks
  },
  plugins:[createPersistedState()]
})
